import storeInfo from 'ducks/store'
import { DiscountsType } from './types'

export const getDiscountsValue = (type: keyof DiscountsType) => (): any => {
  const { discounts } = storeInfo.store.getState()
  // if (!orderMaintenance) return null
  return discounts[type as keyof DiscountsType]
}
